import React from 'react';
import { Portal } from '../types';
import { MyStore, getStoreInitials } from '../hooks/useMyStore';

interface TopBarProps {
  portal: Portal;
  onNavigate: (page: string) => void;
  title?: string;
  subtitle?: string;
  store?: MyStore | null;
}

export const TopBar: React.FC<TopBarProps> = ({ portal, onNavigate, title, subtitle, store }) => {
  const isMfr = portal === 'manufacturer';
  const initials = getStoreInitials(store?.storeName) || (isMfr ? 'M' : 'D');
  const storeName = store?.storeName || '';

  return (
    <header className="h-16 bg-white border-b border-[#F1F5F9] sticky top-0 z-20 shrink-0 flex items-center justify-between px-6">
      <div className="flex flex-col justify-center">
        <h1 className="text-xl font-bold text-[#0F172A] m-0">{title || 'Dashboard'}</h1>
        <p className="text-[12px] text-[#94A3B8] m-0 mt-[2px] font-normal italic">
          {subtitle || (isMfr ? 'Manufacturer Operations Control' : 'Distributor Sales Access')}
        </p>
      </div>

      <div className="flex items-center gap-3">
        <button className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          {storeName && (
            <span className="hidden md:inline text-[13px] font-semibold text-[#0F172A] max-w-[180px] truncate">
              {storeName}
            </span>
          )}
          <div
            className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-purple-600 flex items-center justify-center text-white font-bold text-[12px] shadow-sm"
            title={storeName}
          >
            {initials}
          </div>
        </button>
      </div>
    </header>
  );
};
